import { render, staticRenderFns } from "./BIEmitterSummary.vue?vue&type=template&id=d80f2e1e"
import script from "./BIEmitterSummary.vue?vue&type=script&lang=js"
export * from "./BIEmitterSummary.vue?vue&type=script&lang=js"
import style0 from "./BIEmitterSummary.vue?vue&type=style&index=0&id=d80f2e1e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports